import map from 'lodash/map';

import { getDoc, getDocs, getDropdownList, saveDoc } from '../apiCommon';
import { filterCustomFieldsByViewMode } from '../apiUtils';
import { SALE_TRANSACTION } from '../../constants/constant_doc_types';
import { fetchAddress } from '../../components/common/form/fields/address_search/AddressSearchFieldServices';

export const fetchSaleTransactionById = async (app, params) => {
  const { id, path, haveCustomFields } = params;
  const docType = SALE_TRANSACTION;
  const doc = await getDoc(
    app,
    { id, docType },
    { assemble_custom_fields: haveCustomFields },
  );

  doc.item_lines = map(doc.item_lines, itemLine =>
    filterCustomFieldsByViewMode(itemLine, path),
  );

  return filterCustomFieldsByViewMode(doc, path);
};

export const fetchSaleTransactionByIds = async (app, params) => {
  const doc_type = SALE_TRANSACTION;
  const docs = await getDocs(app, { doc_type, ...params });
  return docs;
}

export const fetchSaleTransactionDropdown = (app, params) => {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'sale_transaction/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams,
  };

  return getDropdownList(app, { query });
};

export async function saveSaleTransaction(app, dataToSave) {
  const { data } = dataToSave;
  const { delivery_address, isGetGeo } = data;

  if (isGetGeo) {
    const {
      address1,
      address2,
      address3,
      city,
      country,
      state,
      zipcode,
    } = delivery_address;

    const addressTermStrBuff = [];

    if (address1) addressTermStrBuff.push(address1);
    if (address2) addressTermStrBuff.push(address2);
    if (address3) addressTermStrBuff.push(address3);
    if (city) addressTermStrBuff.push(city);
    if (state) addressTermStrBuff.push(state);
    if (zipcode) addressTermStrBuff.push(zipcode);
    if (country.name) addressTermStrBuff.push(country.name);

    const addressTerm = addressTermStrBuff.join(', ');
    const result = await fetchAddress(app, addressTerm);

    data.delivery_address.lat = result.lat;
    data.delivery_address.lng = result.lng;
  }

  return saveDoc(app, {
    source: data,
    doc: data,
  });
}

export function saveSaleTransactionItemLine(app, data) {
  const { id } = data;
  const service = app.service('sale_transaction/item_line');
  return service.patch(id, data);
}